module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado20+.de435119.svg";